import { render, staticRenderFns } from "./WordParaphrase.vue?vue&type=template&id=89368d7a"
import script from "./WordParaphrase.vue?vue&type=script&lang=js"
export * from "./WordParaphrase.vue?vue&type=script&lang=js"
import style0 from "./WordParaphrase.vue?vue&type=style&index=0&id=89368d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports